// Uploaded-file preparation.
//
// NOTE: client-side image *re-encoding* (canvas.toBlob) is intentionally
// DISABLED. It corrupted uploaded photos — re-encoding produced structurally
// valid but visually garbled JPEGs (1px vertical-stripe pattern), which is
// unacceptable for a document-collection form (CVs, criminal records, ID
// photos must be byte-for-byte intact). Files are now uploaded as-is.
//
// Durability is handled server-side (Google Cloud Storage), so compression is
// no longer needed for that. If large mobile photos ever become a measured
// upload-reliability problem, re-introduce shrinking via a battle-tested
// library (e.g. browser-image-compression) — NOT hand-rolled canvas code — and
// verify the output decodes correctly before shipping.

/** Hard per-file ceiling (mirrors the backend's MAX_FILE_SIZE). */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

/** Pass the file through untouched. Kept as a hook for future, vetted resizing. */
export async function prepareUploadFile(file: File): Promise<File> {
  return file;
}
